import { useEffect, useState } from "react"
import { SetupBillingDrawer } from "./setupBilling.drawer";
import { Button } from "antd";
import { faEdit, faTrash, faCalendar, faClock, faRotate, faShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";
import { getKeyholdingSiteBillingBySiteIdQuery } from "@src/util/query/keyholdingSiteBilling.query";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import Spinner from "@src/components/spinner";
import { DeleteKeyholdingSiteBillingMutation } from "@src/util/mutation/keyholdingSiteBilling.mutation";
import { setNotification } from "@src/middleware/redux/reducers/notification.reducer";
import { useDispatch } from "react-redux";
import { DownloadKeyholdingTemplateMutation } from "../../../../../util/mutation/keyholdingSiteBilling.mutation";


export const SiteBilling = ({siteId=null}) => {
    
    const params = useParams();

    const [setupBilling, setSetupBilling] = useState(false);

    const [editData, setEditData] = useState({});

    const dispatch = useDispatch();
    
    const [downloadKeyHoldingTemplate] = useMutation(DownloadKeyholdingTemplateMutation);

    function downloadBase64File(
        base64Data,
        filename,
        contentType
      ) {
        const byteString = atob(base64Data);
        const byteArray = new Uint8Array(byteString.length);
      
        for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
        }
      
        const blob = new Blob([byteArray], { type: contentType });
      
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
      
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
      
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
      

    const importBill = async()=>{
        try{
            const { data } = await downloadKeyHoldingTemplate();

            const {
                filename,
                contentType,
                base64Data
            } = data.downloadKeyholdingTemplate;

            downloadBase64File(base64Data, filename, contentType);

        }catch(err){

        }
    };

    const {data, loading, refetch} = useQuery(getKeyholdingSiteBillingBySiteIdQuery,{
        variables:{
            siteId: params?.id || siteId
        },
        fetchPolicy:'network-only'
    });

    const onDelete = async(id)=>{

        await deleteKeyholdingSiteBilling({
            variables:{
                planId: id
            }
        });

        dispatch(
            setNotification({
                error: false,
                notificationState: true,
                message: "Action was successful"
            })
        );

        await refetch();

    };


    const getCurrencySymbol = (currency) => {
        switch(currency) {
            case 'USD': return '$';
            case 'EUR': return '€';
            case 'GBP':
            default: return '£';
        }
    };

    const getNextBillingDate = (startDate, period) => {
        const start = new Date(startDate); // your initial billing date
        const now = new Date();
        let nextDate = new Date(start);
    
        if (period === 'month') {
            // keep adding months until the nextDate is after now
            while (nextDate <= now) {
                nextDate.setMonth(nextDate.getMonth() + 1);
            }
        } else if (period === 'year') {
            // keep adding years until the nextDate is after now
            while (nextDate <= now) {
                nextDate.setFullYear(nextDate.getFullYear() + 1);
            }
        }
    
        return nextDate;
    }


    const [deleteKeyholdingSiteBilling, {loading: deleteKeyholdingSiteBillingLoading}] = useMutation(DeleteKeyholdingSiteBillingMutation);

    const [billingPlans, setBillingPlans] = useState([]);

    useEffect(()=>{
        if(data?.getKeyholdingSiteBillingBySiteId?.response){
            setBillingPlans(data?.getKeyholdingSiteBillingBySiteId?.response)
        }
    },[data?.getKeyholdingSiteBillingBySiteId?.response]);


    return (
        <div style={{ width: '100%', padding: '0' }}>

            {
            loading?
            <Spinner />
            :
            billingPlans && billingPlans.length > 0 ? (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))',
                    gap: '20px',
                    width: '100%'
                }}>
                    {billingPlans.map((plan) => (
                        <div
                            key={plan.id}
                            style={{
                                background: 'linear-gradient(135deg, #ffffff 0%, #f8fcff 100%)',
                                border: '1px solid #e6f0f5',
                                borderRadius: '12px',
                                padding: '24px',
                                position: 'relative',
                                boxShadow: '0 2px 8px rgba(0, 145, 174, 0.08)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                overflow: 'hidden'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 145, 174, 0.15)';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 145, 174, 0.08)';
                                e.currentTarget.style.transform = 'translateY(0)';
                            }}
                        >
                            {/* Status Badge */}
                            <div style={{
                                position: 'absolute',
                                top: '16px',
                                right: '16px',
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center'
                            }}>
                                <span style={{
                                    backgroundColor: 'active' === 'active' ? '#52c41a' : '#d9d9d9',
                                    color: 'white',
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    {plan.status || "active"}
                                </span>
                            </div>

                            {/* Plan Header */}
                            <div style={{ marginBottom: '20px', paddingRight: '80px' }}>
                                <h3 style={{
                                    margin: '0 0 8px 0',
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    color: '#001529',
                                    lineHeight: '1.3'
                                }}>
                                    {plan.name}
                                </h3>
                                {plan.description && (
                                    <p style={{
                                        margin: 0,
                                        fontSize: '13px',
                                        color: '#8c8c8c',
                                        lineHeight: '1.4'
                                    }}>
                                        {plan.description}
                                    </p>
                                )}
                            </div>

                            {/* Price Display */}
                            <div style={{
                                background: 'linear-gradient(135deg, #0091ae 0%, #006d85 100%)',
                                borderRadius: '10px',
                                padding: '20px',
                                marginBottom: '20px',
                                textAlign: 'center',
                                boxShadow: '0 4px 12px rgba(0, 145, 174, 0.2)'
                            }}>
                                <div style={{
                                    fontSize: '36px',
                                    fontWeight: 800,
                                    color: 'white',
                                    lineHeight: '1',
                                    marginBottom: '8px'
                                }}>
                                    {getCurrencySymbol(plan.currency)}{plan.rate.toFixed(2)}
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                    fontWeight: 500
                                }}>
                                    per {plan.per}
                                </div>
                            </div>

                            {/* Plan Details */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '12px',
                                marginBottom: '20px'
                            }}>
                                {/* Payment Timing */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '10px 12px',
                                    background: plan.paymentTiming === 'upfront' ? '#e6f7ff' : '#fff7e6',
                                    borderRadius: '8px',
                                    border: `1px solid ${plan.paymentTiming === 'upfront' ? '#91d5ff' : '#ffd591'}`
                                }}>
                                    <FontAwesomeIcon 
                                        icon={faClock} 
                                        style={{ 
                                            color: plan.paymentTiming === 'upfront' ? '#1890ff' : '#fa8c16',
                                            fontSize: '14px'
                                        }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500 }}>
                                            Payment
                                        </div>
                                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#262626' }}>
                                            {plan.paymentTiming === 'upfront' ? 'Upfront' : 'In Arrears'}
                                        </div>
                                    </div>
                                </div>

                                {/* Next Billing */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '10px 12px',
                                    background: '#f6ffed',
                                    borderRadius: '8px',
                                    border: '1px solid #b7eb8f'
                                }}>
                                    <FontAwesomeIcon 
                                        icon={faCalendar} 
                                        style={{ color: '#52c41a', fontSize: '14px' }}
                                    />
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500 }}>
                                            Next Billing
                                        </div>
                                        <div style={{ fontSize: '13px', fontWeight: 600, color: '#262626' }}>
                                            {getNextBillingDate(plan?.startDate, plan?.per).toLocaleDateString('en-GB', { 
                                                day: 'numeric', 
                                                month: 'short', 
                                                year: 'numeric' 
                                            })}
                                        </div>
                                    </div>
                                </div>

                                {/* Bottom Row - Auto Renew & Grace Period */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '12px'
                                }}>
                                    {/* Auto Renew */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '10px 12px',
                                        background: plan.autoRenew ? '#f6ffed' : '#fafafa',
                                        borderRadius: '8px',
                                        border: `1px solid ${plan.autoRenew ? '#b7eb8f' : '#d9d9d9'}`
                                    }}>
                                        <FontAwesomeIcon 
                                            icon={faRotate} 
                                            style={{ 
                                                color: plan.autoRenew ? '#52c41a' : '#8c8c8c',
                                                fontSize: '12px'
                                            }}
                                        />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '10px', color: '#8c8c8c', fontWeight: 500 }}>
                                                Auto-Renew
                                            </div>
                                            <div style={{ 
                                                fontSize: '12px', 
                                                fontWeight: 600, 
                                                color: plan.autoRenew ? '#52c41a' : '#8c8c8c'
                                            }}>
                                                {plan.autoRenew ? 'Yes' : 'No'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Grace Period */}
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        padding: '10px 12px',
                                        background: '#fff7e6',
                                        borderRadius: '8px',
                                        border: '1px solid #ffd591'
                                    }}>
                                        <FontAwesomeIcon 
                                            icon={faShield} 
                                            style={{ color: '#fa8c16', fontSize: '12px' }}
                                        />
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '10px', color: '#8c8c8c', fontWeight: 500 }}>
                                                Grace Period
                                            </div>
                                            <div style={{ fontSize: '12px', fontWeight: 600, color: '#262626' }}>
                                                {plan.terminationGraceDays} days
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Start Date */}
                            <div style={{
                                fontSize: '11px',
                                color: '#8c8c8c',
                                marginBottom: '16px',
                                paddingTop: '12px',
                                borderTop: '1px solid #f0f0f0'
                            }}>
                                Started: {new Date(plan.startDate).toLocaleDateString('en-GB', { 
                                    day: 'numeric', 
                                    month: 'short', 
                                    year: 'numeric' 
                                })}
                            </div>

                            {/* Action Buttons */}
                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                paddingTop: '16px',
                                borderTop: '1px solid #f0f0f0'
                            }}>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setEditData(plan);
                                        setSetupBilling(true);
                                    }}
                                    style={{
                                        flex: 1,
                                        padding: '10px 16px',
                                        backgroundColor: 'rgb(255, 122, 89)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgb(255, 143, 115)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgb(255, 122, 89)';
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                    Edit
                                </button>
                                <Popconfirm
                                    title="Delete billing plan"
                                    description="Are you sure you want to delete this billing plan?"
                                    onConfirm={(e) => {
                                        e.stopPropagation();
                                        onDelete(plan._id);
                                    }}
                                    style={{color:'white'}}
                                    okText="Yes"
                                    cancelText="No"
                                    okButtonProps={{ style: { backgroundColor: '#ff4d4f' } }}
                                >
                                    <button
                                        onClick={async(e) => {

                                            e.stopPropagation();
                                        }}
                                        style={{
                                            padding: '10px 16px',
                                            backgroundColor: '#fff1f0',
                                            color: '#ff4d4f',
                                            border: '1px solid #ffccc7',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#ff4d4f';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#fff1f0';
                                            e.currentTarget.style.color = '#ff4d4f';
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </Popconfirm>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{
                    padding: '60px 20px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
                    border: '1px dashed #d9d9d9',
                    borderRadius: '12px'
                }}>
                    
                    <FontAwesomeIcon 
                        icon={faShield}
                        style={{
                            fontSize: '48px',
                            color: '#0091ae',
                            marginBottom: '20px'
                        }}
                    />
                
                    <h3 style={{
                        fontSize: '20px',
                        fontWeight: '700',
                        color: '#001529',
                        marginBottom: '10px'
                    }}>
                        No Billing Plan Found
                    </h3>
                
                    <p style={{
                        fontSize: '14px',
                        color: '#8c8c8c',
                        maxWidth: '360px',
                        marginBottom: '24px',
                        lineHeight: '1.5'
                    }}>
                        Set up your site billing to start recurring monthly or yearly charging with fixed rates.
                    </p>
                
                    <div style={{display:'flex', gap:'20px'}}>
                        <Button 
                            className="grid-filed-btn"
                            onClick={() => setSetupBilling(true)}
                        >
                            Setup Billing
                        </Button>
                        <Button 
                            className="grid-filed-btn"
                            onClick={importBill}
                        >
                            Import Billing
                        </Button>
                    </div>
                </div>
                
            )}
            <SetupBillingDrawer siteId={siteId} refetch={refetch} editData={editData} visible={setupBilling} close={()=>{setSetupBilling(false); setEditData({}); }} />
        </div>
    );
};